import React, {FC, useState} from "react"

import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"
import tracking from "@irati-tracking/homepage"

import ContentHover from "./ContentHover"
import DeleteTileModal from "../DeleteTileModal"
import EditTileModal from "../NewContent/EditTileModal"
import Empty from "./Empty"
import Image from "./Image"
import LinkWrapper from "./LinkWrapper"
import Template from "./Template"
import Video from "./Video"
import {HomePageView} from "../../types"
import {StyledCol} from "./styled"

interface Props {
  companyNewsTile: CompanyNewsTile
  pageView: HomePageView
}

const ContentColumn: FC<Props> = ({companyNewsTile, pageView}) => {
  const [isOnHover, setHover] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)

  const isHoverStateEnabled = companyNewsTile.config.type !== CompanyNewsTileType.Empty && pageView === HomePageView.EDIT_CONTENT_VIEW

  const {columnWidth} = companyNewsTile.config

  return (
    <StyledCol
      lg={columnWidth}
      md={columnWidth < 4 ? 6 : columnWidth}
      xs={12}
      onMouseEnter={() => {
        if (isHoverStateEnabled) {
          setHover(true)
        }
      }}
      onMouseLeave={() => {
        if (isHoverStateEnabled) {
          setHover(false)
        }
      }}>
      {isHoverStateEnabled && (
        <ContentHover
          handleDeleteTile={() => {
            tracking.homePageDeleteTileModal()
            setShowDeleteModal(true)
          }}
          handleEditTile={() => {
            setShowEditModal(true)
            setHover(false)
          }}
          isOnHover={isOnHover}
        />
      )}

      {companyNewsTile.config.type === CompanyNewsTileType.Empty && pageView !== HomePageView.EMPLOYEE_VIEW && (
        <Empty companyNewsTile={companyNewsTile} />
      )}

      {companyNewsTile.config.type === CompanyNewsTileType.Image && (
        <LinkWrapper companyNewsTile={companyNewsTile}>
          <Image companyNewsTile={companyNewsTile} />
        </LinkWrapper>
      )}

      {companyNewsTile.config.type === CompanyNewsTileType.Video && <Video companyNewsTile={companyNewsTile} />}

      {companyNewsTile.config.type === CompanyNewsTileType.Template && (
        <LinkWrapper companyNewsTile={companyNewsTile}>
          <Template companyNewsTile={companyNewsTile} />
        </LinkWrapper>
      )}

      {showDeleteModal && <DeleteTileModal companyNewsTile={companyNewsTile} onClose={() => setShowDeleteModal(false)} />}
      {showEditModal && <EditTileModal companyNewsTile={companyNewsTile} onClose={() => setShowEditModal(false)} />}
    </StyledCol>
  )
}

export default ContentColumn
